const formatName = ({ firstName, middleName, lastName, suffix }) =>
  `${firstName || ""} ${middleName || ""} ${lastName || ""} ${suffix || ""}`
    .replace(/\s\s+/g, " ")
    .trim();

export default formatName;
